import { Injectable } from '@angular/core';

import { StorageService } from '@uoa/auth';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class AppStorageService implements StorageService {
  private _storage: Storage | null = null;
  constructor(private readonly storage: Storage) {
    this.init();
  }

  init(): void {
    this.storage.create()
        .then((s: Storage) => {
          this._storage = s;
        })
        .catch(err => {
          this._storage = null;
          console.error(`Error creating AppStorageService: ${err}`);
        });
  }

  getItem(key: string): Promise<any> {
    return this.storage.get(key);
  }

  setItem(key: string, val: any): Promise<void> {
    return this.storage.set(key, val);
  }

  removeItem(key: string): void {
    this.storage.remove(key);
  }
}
